import React, { FunctionComponent, useEffect, useState } from 'react';
import classnames from 'classnames';
import { filterBy } from '@progress/kendo-data-query';
import {
  MultiSelect,
  MultiSelectFilterChangeEvent,
  MultiSelectProps,
} from '@progress/kendo-react-dropdowns';
import style from './MultiSelectCustom.module.scss';

interface BrassMultiSelectCustomProps extends MultiSelectProps {
  onFilterChangeCustom?: (event: MultiSelectFilterChangeEvent) => void;
}

const BrassMultiSelectCustom: FunctionComponent<BrassMultiSelectCustomProps> = (
  props: BrassMultiSelectCustomProps,
) => {
  const { className, data, onFilterChangeCustom } = props;
  const _className = classnames(
    'brass-multiselect',
    style['brass-multiselect'],
    className,
  );
  const [dataFiltered, setDataFiltered] = useState<any[] | undefined>(data);

  useEffect(() => setDataFiltered(data), [data]);

  const onFilterChange = (event: MultiSelectFilterChangeEvent) =>
    setDataFiltered(filterBy(dataFiltered || [], event.filter));

  const onClose = () => setDataFiltered(data);

  return (
    <div className={style['brass-multiselect']}>
      <MultiSelect
        {...props}
        data={dataFiltered}
        className={_className}
        onFilterChange={(event: MultiSelectFilterChangeEvent) => {
          onFilterChange(event);
          if (onFilterChangeCustom) {
            onFilterChangeCustom(event);
          }
        }}
        onClose={onClose}
      />
    </div>
  );
};

export { BrassMultiSelectCustom };
export type { BrassMultiSelectCustomProps };
